import React from 'react';
import './YearSelector.css';
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const YearSelector = ({ selectedYear, onYearChange, availableYears, disabled = false }) => {
  const currentIndex = availableYears.findIndex(y => y.value === selectedYear);
  
  const handlePrevious = () => {
    if (currentIndex > 0) {
      onYearChange(availableYears[currentIndex - 1].value);
    }
  };
  
  const handleNext = () => {
    if (currentIndex < availableYears.length - 1) {
      onYearChange(availableYears[currentIndex + 1].value);
    }
  };
  
  return (
    <div className={`year-selector ${disabled ? 'disabled' : ''}`}>
      <div className="year-selector-label">
        <FaCalendarAlt />
        <span>Village Data Year</span>
      </div>
      
      <div className="year-selector-controls">
        <button
          className="year-nav-btn"
          onClick={handlePrevious}
          disabled={disabled || currentIndex === 0}
          title="Previous Year"
        >
          <FaChevronLeft />
        </button>
        
        <select
          className="year-dropdown"
          value={selectedYear}
          onChange={(e) => onYearChange(e.target.value)}
          disabled={disabled}
        >
          {availableYears.map(year => (
            <option key={year.value} value={year.value}>
              {year.label}
            </option>
          ))}
        </select>
        
        <button
          className="year-nav-btn"
          onClick={handleNext}
          disabled={disabled || currentIndex === availableYears.length - 1}
          title="Next Year"
        >
          <FaChevronRight />
        </button>
      </div>
      
      <div className="year-selector-info">
        <span className="year-badge">{selectedYear}</span>
      </div>
    </div>
  );
};

export default YearSelector;
